<template lang="html">
    <b-modal v-model="showFrqModal" title="IP Frequency Levels"  @hide=" $emit('update:is-show', false)" hide-footer>
      <div>
        Level 1 - IP Only<br />
        Level 2 - IP and UA<br />
        Level 3 - IP, UA and Bundle<br />
        Level 4 - IP, UA, Lat and Lon<br />
        Level 5 - IP, UA, Lat, Lon and Bundle
      </div>
    </b-modal> 
</template>
<script>
    
export default {
    
    props: ['isShow'],
    data() {
        return {

        }
    },
    created(){

    },
    computed: {
        showFrqModal: {
            get: function() {
                return this.isShow
            },
            set: function() {

            }
        }
    },
    methods: {

    },    
}
</script>
<style scoped>

</style>